'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('./util');

function EventDispatcher(target) {
  this._listeners = {};
  this._eventTarget = target || {};
  this.recoverLists = [];
  this._listFun = {};
}
EventDispatcher.prototype = {
  addEventListener: function addEventListener(type, callback, target) {
    var types = type.split('.');
    var _type = types[0];
    var namespaces = types[1];
    var listName = '' + _type + (target ? '_' + target.getAttribute('id') : '');
    var list = this._listeners[listName];
    var index = 0;
    var listener = void 0;
    var i = void 0;
    if (!list) {
      this._listeners[listName] = list = [];
    }
    i = list.length;

    while (--i > -1) {
      listener = list[i];
      if (listener.n === namespaces && listener.c === callback) {
        list.splice(i, 1);
      } else if (index === 0) {
        index = i + 1;
      }
    }
    var $target = target || this._eventTarget;
    list.splice(index, 0, { c: callback, n: namespaces, t: _type });
    if (!this._listFun[listName]) {
      this._listFun[listName] = this._listFun[listName] || this.dispatchEvent.bind(this, _type);
      if ($target.addEventListener) {
        $target.addEventListener(_type, this._listFun[listName], false);
      } else if ($target.attachEvent) {
        $target.attachEvent('on' + _type, this._listFun[listName]);
      }
    }
  },
  removeEventListener: function removeEventListener(type, callback, target, force) {
    var types = type.split('.');
    var _type = types[0];
    var namespaces = types[1];
    var listName = '' + _type + (target ? '_' + target.getAttribute('id') : '');
    var list = this._listeners[listName];
    var i = void 0;
    var _force = force;
    if (!namespaces) {
      _force = true;
    }
    if (list) {
      i = list.length;
      var $target = target || this._eventTarget;
      while (--i > -1) {
        if (list[i].c === callback && (_force || list[i].n === namespaces)) {
          list.splice(i, 1);
          if (!list.length) {
            var func = this._listFun[listName];
            delete this._listeners[listName];
            delete this._listFun[listName];
            if ($target.removeEventListener) {
              $target.removeEventListener(_type, func);
            } else if ($target.detachEvent) {
              $target.detachEvent('on' + _type, func);
            }
          }
          if (!_force) {
            return;
          }
        }
      }
    }
  },
  dispatchEvent: function dispatchEvent(type, e) {
    var target = e.target;
    var listName = '' + type + (target.getAttribute ? '_' + target.getAttribute('id') : '');
    var list = this._listeners[listName];
    var i = void 0;
    var t = void 0;
    var listener = void 0;
    if (list) {
      i = list.length;
      t = this._eventTarget;
      while (--i > -1) {
        listener = list[i];
        if (listener) {
          var _e = e || { type: type, target: t };
          listener.c.call(t, _e);
        }
      }
    }
  },
  removeAllType: function removeAllType(type, target) {
    var _this = this;

    var types = type.split('.');
    var _type = types[0];
    var namespaces = types[1];
    var listName = '' + _type + (target ? '_' + target.getAttribute('id') : '');
    var list = this._listeners[listName];
    this.recoverLists = this.recoverLists.concat((0, _util.dataToArray)(list).filter(function (item) {
      return item.n && item.n.match(namespaces);
    }));
    this.recoverLists.forEach(function (item) {
      _this.removeEventListener(item.t + '.' + item.n, item.c, target);
    });
  },
  reAllType: function reAllType(type, target) {
    var _this2 = this;

    var types = type.split('.');
    var _type = types[0];
    var namespaces = types[1];
    this.recoverLists = this.recoverLists.map(function (item) {
      if (item.t === _type && item.n.match(namespaces)) {
        _this2.addEventListener(item.t + '.' + item.n, item.c, target);
        return null;
      }
      return item;
    }).filter(function (item) {
      return item;
    });
  }
};
var event = void 0;
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  event = new EventDispatcher(window);
} else {
  event = new EventDispatcher();
}
exports['default'] = event;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-scroll-anim/lib/EventDispatcher.js
// module id = 91
// module chunks = 55213770944713 173894859265406